import { VhcCreatePage } from '.';
import { useIsInIframe } from 'features/notifications/hooks/use-is-in-Iframe';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useThemeMode } from 'theme/contexts/theme';

export const VhcCreatePageWrapper = () => {
  const isInIframe = useIsInIframe();
  const { mode, updateMode } = useThemeMode();

  useEffect(() => {
    if (isInIframe) {
      if (mode == 'dark') updateMode('light');
    }
  }, [isInIframe]);

  return (
    <>
      <VhcCreatePage />
      <ToastContainer autoClose={2000} theme="light" />
    </>
  );
};
